import { render, staticRenderFns } from "./CareerCounseling.vue?vue&type=template&id=5eb92293&scoped=true"
import script from "./CareerCounseling.vue?vue&type=script&lang=js"
export * from "./CareerCounseling.vue?vue&type=script&lang=js"
import style0 from "./CareerCounseling.vue?vue&type=style&index=0&id=5eb92293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb92293",
  null
  
)

export default component.exports